/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { createContext, useEffect, useMemo } from 'react'
import { Container, Grid } from '@mui/material';

// @assets
import { GeneralStyles } from '../../assets/css/general-style';

// @components
import Pageheader from '../../components/PageHeader';
import TicketTable from './components/TicketTable';

// @hooks
import useTickets from './hooks/UseTickets';

const TicketManagement = () => {
  const generalStyle = useMemo(() => GeneralStyles(), []);
  
  const {
    handleMapResponse,
    rowsState,
    setRowsState,
    filterTicket,
    setFilterTicket,
    sortBy,
    setSortBy
  } = useTickets();

  useEffect(() => {
    handleMapResponse();
  }, [])

  return (
      <Container
        component="section"
        maxWidth="xl"
        sx={generalStyle.dashCtn}
      >
        <Container
          component="section"
          maxWidth="xl"
          sx={generalStyle.containerTitle}
        >
          <Pageheader
            title={'Ticket management'}
            subtitle={'Welcome to ticket page'}
          />
        </Container>
  
        <TicketContext.Provider value={{
            rowsState,
            setRowsState,
            handleMapResponse,
            filterTicket,
            setFilterTicket,
            sortBy,
            setSortBy
          }}
        >
          <Grid>
            <TicketTable/>
          </Grid>
        </TicketContext.Provider>
      </Container>
    )
  }
    
export const TicketContext = createContext({});
export default TicketManagement